import React from "react";
import classes from "../Style.css"
import DocPage from "../DocPage/DocPage"

import Figure1 from "./Figures/1.png"
import Figure2 from "./Figures/2.png"

const DocumentationPage = (props) => {

  return (
    <>
      <DocPage title={"Using the Modbus protocol"} link={"https://gateway.allorado.io/docs/protocol-gateway/12.%20Using%20Modbus.pdf"}>
        <div className={classes.docContainer}>

          <p>The Allorado Gateway makes it easy to connect LoRa with Modbus TCP in both directions. You can work with Modbus using the automatic mapper available on the web interface or through open-source NodeRED nodes.</p>
    
          <h3>1. Web interface vs. NodeRED</h3>
          <p>The web interface includes an automatic mapper that links LoRa devices to Modbus. For each provisioned LoRa device, you can choose which values to expose to Modbus — for example, selecting the active power reading of a sensor while excluding reactive power. Once configured, the dataflow is handled automatically, with no further setup required.</p>
          <p>The NodeRED option provides greater flexibility and control, though it requires more manual configuration. With the open-source Modbus nodes, users can create custom flows to expose data via Modbus registers alongside other protocols and nodes. For example, by connecting the Modbus nodes to a LoRa Downlink node, you can switch a LoRa-enabled relay by writing to a register.</p>

          <h3>2. Using the web interface</h3>

          <img style={{ marginTop: "20px", marginBottom: "30px" }} className={classes.structureImage} src={Figure1} alt="Screenshot of the LoRa to Modbus configuration web interface."/>

          <ol>
            <li>Log into your Allorado Gateway</li>
            <li>Head over to the “Advanced” tab, under LoRa</li>
            <li>Activate “LoRa to Modbus</li>
            <li>Head over to the newly created “LoRa to Modbus tab</li>
            <li>Change the default Modbus port number if desired</li>
            <li>Continue to “Device mapping” and for each device, select which data points you would like to map to Modbus registers.</li>
            <li>The mapper will automatically assign a register address and unit ID. Open up “Mapper settings” if you would like to manually configure these.</li>
            <li>When you are satisfied with the configuration, click the “Deploy” button to make the changes take effect.</li>
            <li>Verify the resulting register list in the “Register table” tab.</li>
            <li>You will see values appearing in the newly created registers when polling via Modbus TCP. This can be easily verified by using a third-party Modbus master, like qModMaster.</li>
            <li>When a selected LoRa device transmits a new data, head back over to the “Register table” tab and you will see new value under “Current value”.</li>
          </ol>
    
          <img style={{ marginTop: "20px", marginBottom: "30px" }} className={classes.structureImage} src={Figure2} alt="Screenshot of the resulting Modbus register list."/>
       
        </div>
      </DocPage>
    </>
  );
}

export default DocumentationPage;
